/**
 * Force-load cart drawer recommendations when drawer opens.
 */
(function () {
  function fetchRecs(el) {
    if (!el || el.dataset.loaded === 'true') return;
    const productId = el.dataset.productId;
    const url = el.dataset.url;
    const sectionId = el.dataset.sectionId;
    if (!productId || !url || !sectionId) return;

    el.dataset.loaded = 'true';
    const separator = url.includes('?') ? '&' : '?';
    fetch(`${url}${separator}product_id=${productId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim().length) {
          el.innerHTML = recommendations.innerHTML;
          el.classList.add('product-recommendations--loaded');
        } else {
          el.innerHTML = '';
          el.dataset.loaded = '';
        }
      })
      .catch(() => {
        el.dataset.loaded = '';
      });
  }

  function loadCartRecs(scope) {
    (scope || document)
      .querySelectorAll('product-recommendations[data-cart-recs-immediate]')
      .forEach((el) => {
        el.dataset.loaded = '';
        fetchRecs(el);
      });
  }

  document.addEventListener('shown.bs.offcanvas', (event) => {
    if (!event.target || event.target.id !== 'CartDrawer') return;
    loadCartRecs(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => loadCartRecs());
  } else {
    loadCartRecs();
  }
})();
